<div>
  <mat-toolbar color="accent">
    <mat-toolbar-row>
      <button mat-button (click)="onRefresh()">
        <mat-icon aria-hidden="false" aria-label="Refresh">refresh</mat-icon>
        Refresh Statistics
      </button>
      <span class="toolbar-spacer"></span>
      <mat-form-field color="accent">
        <input
          matInput
          placeholder="Search statistics..."
          [(ngModel)]="filter"
          (ngModelChange)="onFilterChange($event)"
        />
      </mat-form-field>
      <button mat-icon-button aria-label="Clear" *ngIf="filter" (click)="onFilterChange('')">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  @if (loading) {
    <div class="loading-container">
      <mat-spinner></mat-spinner>
      <p>Loading Statistics...</p>
    </div>
  } @else {
    <table
      mat-table
      [dataSource]="dataSource"
      class="mat-elevation-z8"
      matSort
      matSortActive="projectName"
      matSortDirection="asc"
      width="100%"
    >
      <ng-container matColumnDef="projectId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Project ID</th>
        <td mat-cell *matCellDef="let item">{{ item.projectId }}</td>
      </ng-container>

      <ng-container matColumnDef="projectName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Project Name</th>
        <td mat-cell *matCellDef="let item">{{ item.projectName }}</td>
      </ng-container>

      <ng-container matColumnDef="activeUserCount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Active Users</th>
        <td mat-cell *matCellDef="let item">{{ item.activeUserCount }}</td>
      </ng-container>

      <ng-container matColumnDef="authorizedUserCount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Authorized Users</th>
        <td mat-cell *matCellDef="let item">{{ item.authorizedUserCount }}</td>
      </ng-container>

      <ng-container matColumnDef="activeUsersByVersion">
        <th mat-header-cell *matHeaderCellDef>Active Users by Version</th>
        <td mat-cell *matCellDef="let item">
          <ng-container *ngIf="versionEntries(item.activeUsersByVersion) as entries">
            <span *ngFor="let e of entries" class="version-badge">
              {{ e.version }}: <strong>{{ e.count }}</strong>
            </span>
            <span *ngIf="entries.length === 0" class="no-data">—</span>
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="authorizedUsersByVersion">
        <th mat-header-cell *matHeaderCellDef>Authorized Users by Version</th>
        <td mat-cell *matCellDef="let item">
          <ng-container *ngIf="versionEntries(item.authorizedUsersByVersion) as entries">
            <span *ngFor="let e of entries" class="version-badge">
              {{ e.version }}: <strong>{{ e.count }}</strong>
            </span>
            <span *ngIf="entries.length === 0" class="no-data">—</span>
          </ng-container>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayColumns"></tr>
    </table>
  }
</div>
